import React,{Component,Fragment} from 'react';
import {allergens, nutritions, updatedNutritions} from '../../../../server/constants.js';
import {allowNumericWithdecimal, convertTwoDecimalPoint, nutritionGroupPan } from '../../../../server/util.js'
import defaultImage from '../../../../assets/meal-bg.jpg'
import './style.css'
import { Row, Col, Badge } from 'react-bootstrap';
const styles = {
    imageStyle:{
            height: '20px',
            width: '20px',
    },
    eggImageStyle:{
            height: '20px',
            width: '10px',
    },
    fishImageStyle:{
            height: '8px',
            width: '20px',
    },
    fishStyle:{
       
        display:"flex",alignItems:"center",padding:'8px 3px',borderRadius:"50%", border:"none !important" 
    },
    allergensButtonStyle : {
        display:"flex",alignItems:"center",padding:'2px',borderRadius:"50%",border:"none !important" 
    },
    eggButtonStyle : {
        display:"flex",alignItems:"center",padding:'2px 6px',borderRadius:"50%",border:"none !important" 
    }
}
class NutritioninfoNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            loading: false,
            nutrientValues: [],
            servings: null,
            size: '',
            sizeWeight: '',
            unit: '',
            nutritionGroupPan: {},
        }
    }

    splitNutritonsByGroup = () => {
        const groupPans = Object.keys(nutritionGroupPan || {});
        const nutObject = {};
        let usedList = [];
        groupPans.map(key => {
            nutObject[key] = this.props.nutritionVal.filter(itm => {
                const res = nutritionGroupPan[key].includes(itm.nutrientCode) && !usedList.includes(itm.nutrientCode);
                if (res) {
                    usedList.push(itm.nutrientCode);
                }
                return res;
            });
        });
        return nutObject;
    }
    render(){
        return(<Fragment>
        <div className="row" style={{marginTop:'10px'}}>
            <div className="col-md-12">
                <h4 className="sub-title text-danger" style={{marginBottom:'10px'}} >{this.props.data.name}</h4>
            </div>
        </div>
        <div className="row">
            <div className="col-md-5">
            <h4 className="sub-title text-danger" style={{marginBottom:'10px'}} >&nbsp;</h4>
              <div style={{
                          height:'125px',
                          padding: '0.3rem',
                          marginBottom:'10px',
                          objectFit: 'cover',
                          border: 'solid #dee2e6',
                          textAlign: "center"}}>
                          <img src={this.props.data.imageUrl ? this.props.data.imageUrl : defaultImage } className="img-fluid" alt="..." style={{
                                  height: '-webkit-fill-available',
                                  width: '-webkit-fill-available',
                                  // inlineSize : "auto"
                          }} />
                          {/* <img src={this.props.data && ((this.props.data.imageUrl || '') === '') ? defaultImage : this.props.data.imageUrl} alt='' width="100%" className="img-fluid img-thumbnail" /> */}
                      </div>
                      <div style={{paddingTop: '10%'}}>
      <h5 className="sub-title text-danger" >{'Allergens'}</h5>
          {
            ( ( this.props.data || {} ).allergensInfo || [] ).length <= 0 ?
            <div className='col-md-12 text-center'><span>No Allergens</span></div>
              : Object.keys(allergens).map((itm, i)=>{
                return (<Fragment>
                       {this.props.data.allergensInfo && this.props.data.allergensInfo.includes(itm) && 
                       <div className="mr-4 col-sm-6 col-md-6" style={{display:"flex",flexDirection:"column",alignItems:"center",textAlign:"center",marginBottom:"8px",padding:"0px"}}>
                        <button onClick={ (e) => { e.preventDefault() }} 
                                class={`${(this.props.data.allergensInfo && this.props.data.allergensInfo.includes(itm)) ? 'btn-primary' : 'btn-allergens'}`} 
                                style={itm !== 'fish' ? (itm!=='eggs' ? styles.allergensButtonStyle : styles.eggButtonStyle): styles.fishStyle}>
                                <img src={allergens[itm].image} className="img-fluid" alt="..." style={itm !== 'fish' ? (itm!=='eggs' ? styles.imageStyle : styles.eggImageStyle) : styles.fishImageStyle} />
                        </button>
                        <span className="" style={{width: '65%', background: 'transparent', border: '0' }}>{itm}</span>
                        </div> 
                       }
                     </Fragment>
                    )
           })  
        }                
        </div>
                </div>
            <div className="col-md-6 cust-table" style={{width: '57%', paddingLeft: '5%'}}>
            <div style={{ fontSize: '11px' }}>
             <p className="text-left fs--1" style={{fontSize: '1.75rem', fontWeight: 'bold'}}>Nutrition Facts</p>
            {this.props.servings && (
              <Fragment>
               <Row className="border-top" style={{paddingLeft:'3%'}}>
                 <Col className="text-left">
                  <label className="fs--1">{`${((this.props.servings.size || '').toString().length > 0) ? `${(this.props.servings.size || '')} servings per container` : 'NA'}`}</label>
                 </Col>
               </Row>
               <Row className="border-bottom" style={{paddingLeft:'3%'}}>
                <Col className="text-left" style={{marginLeft: '-3px'}}>
                 <span style={{fontSize: '1.75rem', fontWeight: 'bold',}}>Serving size</span>
                </Col>
                <Col style={{marginLeft:'50%', fontSize: '1.50rem', fontWeight: 'bold'}}>
                 <label className="fs-5 fw-bold">{`${((this.props.servings.sizeWeight || '').length > 0 || (this.props.servings.unit || '').length > 0) ? this.props.servings.sizeWeight + ' [' + ((this.props.servings.unit || '').length > 0 ? this.props.servings.unit : 'NA') + ']' : 'NA'}`}</label>
               </Col>
              </Row>
            </Fragment>
        )}

        {this.props.nutritionVal.length === 0  && (
          <Row>
            <Col className="text-center fw-lighter fs-6">
              <span>No nutrition information found</span>
            </Col>
          </Row>
        )}

        {Object.keys(nutritionGroupPan || {}).map((key, j) => {
          const groupData = this.splitNutritonsByGroup(); 
          const _nutrientValues = groupData[key];
          if (_nutrientValues.length === 0) return false;

          return (
            <div key={key}>
              {_nutrientValues.map((item, i) => {
                if (!item.nutrientDescription) return undefined;

                return (
                  <Fragment key={i}>
                    {j === 0 && (
                      <Row className="pb-1 border-bottom">
                        <Col className=" col-md-12 text-left" style={{marginRight:'-22px'}}>
                          <span className="fs--1">Amount per serving</span>
                        </Col>
                        <Col className="col-md-12 text-left" style={{marginTop: '20px', marginLeft: '-250px', fontSize: '1.50rem', fontWeight: 'bold'}}>
                          <span className="fw-bolder fs-1">
                            {`${item.nutrientDescription || ''}`}
                            &nbsp;
                            {item.version ? (
                              <Badge style={{ fontSize: '6px', backgroundColor: 'red', color: 'white' }} >USDA</Badge>
                            ) : (
                              <Badge style={{ fontSize: '8px', backgroundColor: 'green', color: 'white'}} >LOCAL</Badge>
                            )}
                          </span>
                        </Col>
                        <Col className="text-right fw-bolder fs-6" md={3} style={{marginTop: '20px', marginRight:'16px', fontSize: '1.50rem', fontWeight: 'bold'}}>
                          <span>{item.nutrientValue === 0 ? 0 : item.nutrientValue || 'NA'}</span>
                        </Col>
                      </Row>
                    )}

                    {j > 0 && (
                      <Row className="border-bottom">
                        <Col className="col-md-6 text-left border-right col">
                          <span className="fw-bolder" style={{fontSize: '1.25rem', fontWeight: 'bold'}}>
                            {`${item.nutrientDescription || ''} [${item.units || ''}]`}
                            &nbsp;
                            {item.version ? (
                              <Badge style={{ fontSize: '6px', backgroundColor: 'red', color: 'white'}} color="danger">USDA</Badge>
                            ) : (
                              <Badge style={{ fontSize: '8px', backgroundColor: 'green', color: 'white' }} color="success">LOCAL</Badge>
                            )}
                          </span>
                        </Col>
                        <Col className="text-right col-md-3" >
                          <span>{(item.nutrientValue === 0) ? 0 : (item.nutrientValue || 'NA')}</span>
                        </Col>
                        <Col className="text-right col-md-3" >
                          <span>{(item.dailyValue === 0 ) ? 0 : (item.dailyValue || 'NA')}</span>
                        </Col>
                      </Row>
                    )}

                    {(item.subItems || []).map((subNut, subIndex) => {
                      if (!subNut.nutrientDescription) return undefined;

                      return (
                        <Row key={subIndex} className="pb-1 border-bottom">
                          <Col className="col-md-6 text-left border-right">
                            <span style={{ marginLeft: '20px' }}>
                              {`${subNut.nutrientDescription || ''} [${subNut.units || ''}]`}
                              &nbsp;
                              {subNut.version ? (
                                <Badge style={{ fontSize: '6px', backgroundColor: 'red', color: 'white' }} >USDA</Badge>
                              ) : (
                                <Badge style={{ fontSize: '8px', backgroundColor: 'green', color: 'white'}} >LOCAL</Badge>
                              )}
                            </span>
                          </Col>
                          <Col className="text-right col-md-3" >
                            <span>{(subNut.nutrientValue === 0 ) ? 0 : (subNut.nutrientValue ? subNut.nutrientValue : 'NA')}</span>
                          </Col>
                          <Col className="text-right col-md-3" >
                            <span>{(subNut.dailyValue === 0 ) ? 0 : (subNut.dailyValue ? subNut.dailyValue : 'NA')}</span>
                          </Col>
                        </Row>
                      );
                    })}
                  </Fragment>
                );
              })}

              <hr className="m-0 p-0" style={{ backgroundColor: '#000', height: '5px' }} />

              {j === 0 && (
                <Row>
                  <Col sm={12} className="fs--2 text-right" style={{marginLeft:'60%'}}>
                    <strong>{'% DV*'}</strong>
                  </Col>
                </Row>
              )}
            </div>
          );
        })}
      </div>
    </div>
   
 
      </div>
     </Fragment>);
    }
}
export default NutritioninfoNew


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Caterer/MenuMaster/NutritionInfoNew.jsx